/* eslint-disable */
import Vue from 'vue';
import router from '../../routes';

const admin = {
    namespaced: true,
    state:{
        token: '',
        authFailed: false,
        refreshLoading: true,
        validToken:false,
        version: ''
    },
    getters:{
        isAuth(state) {
            if(state.token) {
                return true;
            }else{
                return false;
            }
        },
        refreshLoading(state){
            return state.refreshLoading
        },
        getVersion(state) {
            return state.version;
        },
    },
    mutations: {
        authUser(state,authData) {
            state.authFailed = false;
            state.token = authData.user.token;
        },
        authFailed(state,type) {
            if(type === 'reset') {
                state.authFailed = false;
            }else{
                state.authFailed = true;
            }
        },
        refreshLoading(state){
            state.refreshLoading = false
        },
        logoutUser(state) {
            state.token = null;
            state.authFailed = false;
            localStorage.clear();

            if(window.hasOwnProperty("cordova")){
                window.CacheClear();
            }
        },
        checkToken(state,tokenData) {
            if(tokenData.error==0 && tokenData.userID>0) {
                state.validToken = true;
                state.token = localStorage.getItem('token');
            }
        },
        getVersion(state,versionData) {
            state.version = versionData.version;
            localStorage.setItem("version",versionData.version);
        }
    },
    actions:{
        signIn({commit},payload) {
            Vue.http.post('auth/login',{
                ...payload
            })
                .then(response => response.json())
                .then( authData => {
                    console.log(authData);
                    commit("authUser",{
                        ...authData,
                        type:'signin'
                    });

                    localStorage.setItem("token",authData.user.token);
                })
                .catch( error => {
                    commit("authFailed");
                })
        },
        checkToken({commit},payload) {
            Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

            Vue.http.get('checktoken',{
                ...payload
            })
                .then(response => response.json())
                .then( tokenData => {
                    if(tokenData.error == 0 && tokenData.userID>0) {
                        commit("checkToken",tokenData);
                    }
                })
                .catch( error => {
                    console.log(error);
                })
        },
        refreshToken({commit}){
            const token = localStorage.getItem("token");
            commit("refreshLoading");
        },
        getVersion({commit}){
            Vue.http.get('version',{
            })
                .then(response => response.json())
                .then( versionData => {
                    if(versionData.error == 0) {
                        commit("getVersion",versionData);
                    }
                })
                .catch( error => {
                    console.log(error);
                })
        }
    }
};

export default admin;